import NavBar from "../features/Navbar/Navbar";
import { Cart } from "../features/cart/Cart";



function CartPage() {
    return <div>
      <NavBar/>
      <Cart/>
    </div>;
  }
  export default CartPage;
  